import { useQueryClient } from '@tanstack/react-query';
import { useCallback } from 'react';
import { IntraCompanyQueryKey } from './queryKey';
import { removeInfiniteDataItem } from '@/shared/utils/infiniteDataHelper';
var useRemoveDetailRow = function () {
    var queryClient = useQueryClient();
    var removeDetailRow = useCallback(function (detail) {
        queryClient.setQueryData([IntraCompanyQueryKey.Details, detail.relationCompanyId, detail.userCompanyId], function (oldData) {
            return removeInfiniteDataItem(oldData, function (x) { return x.registrationId === detail.registrationId; });
        });
    }, [queryClient]);
    return { removeDetailRow: removeDetailRow };
};
export default useRemoveDetailRow;
